import { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../utils/init-firebase';
import '../index.css';

const Warranty = () => {
  const [serialNumber, setSerialNumber] = useState('');
  const [warrantyInfo, setWarrantyInfo] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setWarrantyInfo(null);
    
    if (!serialNumber.trim()) {
      setError('Please enter a serial number');
      return;
    }

    setIsLoading(true);
    try {
      const q = query(
        collection(db, 'cloudtree-database'),
        where('Serial Number', '==', serialNumber.trim())
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setError('No warranty information found for this serial number');
        return;
      }

      const doc = querySnapshot.docs[0];
      const data = doc.data();
      
      // Calculate warranty status
      const today = new Date();
      const endDate = data['Warranty End Date'] ? new Date(data['Warranty End Date']) : null;
      const isActive = endDate ? today <= endDate : false;
      
      setWarrantyInfo({
        ...data,
        warrantyStatus: isActive ? 'Active' : 'Expired',
        daysRemaining: endDate ? Math.ceil((endDate - today) / (1000 * 60 * 60 * 24)) : null
      });
    } catch (err) {
      console.error('Error fetching warranty info:', err);
      setError('Error fetching warranty information. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="warranty-page">
      <div className="warranty-container">
        <h1 className="warranty-header">Warranty Check</h1>
        
        <form onSubmit={handleSubmit} className="warranty-form">
          <div className="warranty-input-group">
            <label htmlFor="serialNumber">Enter Serial Number</label>
            <input
              type="text"
              id="serialNumber"
              value={serialNumber}
              onChange={(e) => setSerialNumber(e.target.value)}
              placeholder="Enter device serial number"
              className="warranty-input"
            />
          </div>
          <button type="submit" className="warranty-submit" disabled={isLoading}>
            {isLoading ? 'Checking...' : 'Check Warranty'}
          </button>
        </form>

        {error && <div className="warranty-error">{error}</div>}

        {warrantyInfo && (
          <div className="warranty-info-card">
            <div className="warranty-status" data-status={warrantyInfo.warrantyStatus.toLowerCase()}>
              {warrantyInfo.warrantyStatus}
              {warrantyInfo.daysRemaining !== null && warrantyInfo.warrantyStatus === 'Active' && (
                <span className="days-remaining">
                  ({warrantyInfo.daysRemaining} days remaining)
                </span>
              )}
            </div>
            
            <div className="warranty-details">
              <div className="warranty-detail-row">
                <span className="detail-label">Model:</span>
                <span className="detail-value">{warrantyInfo.Model || 'N/A'}</span>
              </div>
              <div className="warranty-detail-row">
                <span className="detail-label">Make:</span>
                <span className="detail-value">{warrantyInfo.Make || 'N/A'}</span>
              </div>
              <div className="warranty-detail-row">
                <span className="detail-label">Device Type:</span>
                <span className="detail-value">{warrantyInfo['Device Type'] || 'N/A'}</span>
              </div>
              <div className="warranty-detail-row">
                <span className="detail-label">Warranty Start Date:</span>
                <span className="detail-value">{warrantyInfo['Warranty Start Date'] || 'N/A'}</span>
              </div>
              <div className="warranty-detail-row">
                <span className="detail-label">Warranty End Date:</span>
                <span className="detail-value">{warrantyInfo['Warranty End Date'] || 'N/A'}</span>
              </div>
              <div className="warranty-detail-row">
                <span className="detail-label">Support Type:</span>
                <span className="detail-value">{warrantyInfo['Support Type'] || 'N/A'}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Warranty; 